/**
 * Where a FYP visitor came from (109O S1, d1/analytics/0048): an ad, or
 * everyone else. Decided once, on the page the visit landed on, and kept for
 * the tab, so a tap through to the profile or a product does not turn an ad's
 * visitor into an organic one.
 */

export const FYP_SOURCES = ["iklan", "organik"] as const;
export type FypSource = (typeof FYP_SOURCES)[number];

/** Click ids ad networks add to the address of a click on an ad. */
const AD_CLICK_IDS = ["fbclid", "gclid", "gbraid", "wbraid", "ttclid", "msclkid", "twclid", "li_fat_id"] as const;
const PAID_MEDIUM = /^(cpc|ppc|cpm|cpv|paid|paid[_-]?social|paidsocial|ads?|display|sponsored)$/i;

/**
 * `iklan` when the address carries an ad's mark (a click id, or a paid
 * utm_medium) or the visit is a funnel's FYP version; `organik` otherwise. A
 * link shared from the feed's Kongsi (sh=) is organic even when it kept a
 * click id from the visit it was copied in.
 */
export function fypSourceOf(search: string, opts: { funnel?: boolean } = {}): FypSource {
  const q = new URLSearchParams(search);
  if (q.get("sh")) return "organik";
  if (opts.funnel) return "iklan";
  if (AD_CLICK_IDS.some((k) => q.get(k))) return "iklan";
  if (PAID_MEDIUM.test(q.get("utm_medium") ?? "")) return "iklan";
  return "organik";
}

export const fypSourceOk = (v: unknown): v is FypSource => v === "iklan" || v === "organik";

/** The source as it rides on a checkout's address (fs=i|o), and back. */
export const fypSourceParam = (s: FypSource) => (s === "iklan" ? "i" : "o");
export const fypSourceFromParam = (v: string | null): FypSource | null => (v === "i" ? "iklan" : v === "o" ? "organik" : null);
